
import Modal from "src/components/common/modal";
import { myOptions } from "src/components/personel/userForm";
import { onlyUnique } from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function FilterForm({
    closeIt, setCurrentProjectPage,
    curFilter, setFilter, currentData,
    defaultFilter
}){
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "Filter"
            width = {"60%"}
        >
            <div className = "mt-3 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentProjectPage(1);
                }}>Clear Filter</span>
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Project Name:</span>
                <select className = "form-control inline" value = {curFilter.projectName} onChange = {e => {
                    setFilter({...curFilter, projectName: e.currentTarget.value});
                    setCurrentProjectPage(1);
                }}>
                    <option value = "">Select</option>
                    {currentData.map(u => u.projectName).filter(onlyUnique).map((u, ui) => <option key = {ui}>{u}</option>)}
                </select>
                {
                curFilter.projectName !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, projectName: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Labor Category:</span>
                <select className = "form-control inline" value = {curFilter.laborCategory} onChange = {e => {
                    setFilter({...curFilter, laborCategory: e.currentTarget.value});
                    setCurrentProjectPage(1);
                }}>
                    <option value = "">Select</option>
                    {currentData.map(u => u.laborCategory).filter(onlyUnique).map((u, ui) => <option key = {ui}>{u}</option>)}
                </select>
                {
                curFilter.laborCategory !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, laborCategory: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Technician:</span>
                <select className = "form-control inline" value = {curFilter.laborName} onChange = {e => {
                    setFilter({...curFilter, laborName: e.currentTarget.value});
                    setCurrentProjectPage(1);
                }}>
                    <option value = "">Select</option>
                    {currentData.map(u => u.laborName).filter(onlyUnique).map((u, ui) => <option key = {ui}>{u}</option>)}
                </select>
                {
                curFilter.laborName !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, laborName: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Department:</span>
                <select className = "form-control inline" value = {curFilter.department} onChange = {e => {
                    setFilter({...curFilter, department: e.currentTarget.value});
                    setCurrentProjectPage(1);
                }}>
                    <option value = "">Select</option>
                    {Object.entries(myOptions.department).map(([key, value], k) => <optgroup label = {key} key = {k}>{value.map((v, vi) => <option key = {vi}>{v}</option>)}</optgroup>)}
                </select>
                {
                curFilter.department !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, department: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Submit Time:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.workLogSubmitTimeMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.workLogSubmitTimeMin}
                    onChange = {e => {
                        setFilter({...curFilter, workLogSubmitTimeMin: e.currentTarget.value});
                        setCurrentProjectPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.workLogSubmitTimeMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.workLogSubmitTimeMax}
                    onChange = {e => {
                        setFilter({...curFilter, workLogSubmitTimeMax: e.currentTarget.value});
                        setCurrentProjectPage(1);
                    }}
                />
                {
                curFilter.workLogSubmitTimeMax || curFilter.workLogSubmitTimeMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, workLogSubmitTimeMin: "", workLogSubmitTimeMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">
                    Planned Start Time:
                </span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.startMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.startMin}
                    onChange = {e => {
                        setFilter({...curFilter, startMin: e.currentTarget.value});
                        setCurrentProjectPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.startMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.startMax}
                    onChange = {e => {
                        setFilter({...curFilter, startMax: e.currentTarget.value});
                        setCurrentProjectPage(1);
                    }}
                />
                {
                curFilter.startMax || curFilter.startMin?
                <span style = {{marginLeft: 10}} onClick = {() => {
                    setFilter({
                        ...curFilter, 
                        startMin: "", startMax: ""
                })}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">
                    Planned End Time:
                </span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.endMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.endMin}
                    onChange = {e => {
                        setFilter({...curFilter, endMin: e.currentTarget.value});
                        setCurrentProjectPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.endMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.endMax}
                    onChange = {e => {
                        setFilter({...curFilter, endMax: e.currentTarget.value});
                        setCurrentProjectPage(1);
                    }}
                />
                {
                curFilter.endMax || curFilter.endMin?
                <span style = {{marginLeft: 10}} onClick = {() => {
                    setFilter({
                        ...curFilter, 
                        endMin: "", endMax: ""
                })}}>❌</span>:
                null
                }
            </div>
            <div className = "mt-3 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentProjectPage(1);
                }}>Clear Filter</span>
            </div>
        </Modal>
    )
}